"use strict";

exports.__esModule = true;
exports.default = exports.TutorialContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _retailTutorial = require("@jsainsburyplc/retail-tutorial");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var TutorialContext = /*#__PURE__*/_react.default.createContext();

exports.TutorialContext = TutorialContext;

var Tutorial = function Tutorial(props) {
  var _useState = (0, _react.useState)(false),
      isDisplayed = _useState[0],
      setIsDisplayed = _useState[1];

  var _useState2 = (0, _react.useState)(),
      data = _useState2[0],
      setData = _useState2[1];

  var fetch = props.fetch,
      project = props.project,
      version = props.version,
      children = props.children,
      environment = props.environment,
      notSkippable = props.notSkippable;
  (0, _react.useEffect)(function () {
    fetch("https://api-" + environment + ".retail-azure.js-devops.co.uk/tutorials/graphql", {
      method: 'POST',
      body: JSON.stringify({
        query: 'query getTutorial($project: String!, $maxVersion: Int!) { tutorial(project: $project, maxVersion: $maxVersion) { version steps { title description image } } hasViewedTutorial(project: $project, maxVersion: $maxVersion) }',
        variables: {
          project: project,
          maxVersion: version
        }
      })
    }).then(function (r) {
      return r.json();
    }).then(function (content) {
      setData(content.data);
      setIsDisplayed(!content.data.hasViewedTutorial);
    });
  }, []);

  var onTutorialClose = function onTutorialClose(notSkipped) {
    setIsDisplayed(false);

    if (!data.hasViewedTutorial && (notSkipped || !notSkippable)) {
      fetch("https://api-" + environment + ".retail-azure.js-devops.co.uk/tutorials/graphql", {
        method: 'POST',
        body: JSON.stringify({
          query: 'mutation UpsertTutorialViewed($project: String!, $version:Int!) { upsertTutorialViewed(project:$project, version:$version) { isSuccess } }',
          variables: {
            project: project,
            version: version
          }
        })
      });
      setData(Object.assign({}, data, {
        hasViewedTutorial: true
      }));
    }
  };

  return /*#__PURE__*/_react.default.createElement(TutorialContext.Provider, {
    value: {
      isDisplayed: isDisplayed,
      showTutorial: function showTutorial() {
        return setIsDisplayed(true);
      }
    }
  }, children, !isDisplayed || !data ? null : /*#__PURE__*/_react.default.createElement(_retailTutorial.Tutorial, {
    displayTutorial: true,
    steps: data.tutorial.steps,
    onCloseTutorial: onTutorialClose,
    notSkippable: notSkippable
  }));
};

Tutorial.propTypes = {
  children: _propTypes.default.node.isRequired,
  fetch: _propTypes.default.func.isRequired,

  /** The name of the project for the tutorial */
  project: _propTypes.default.string.isRequired,

  /** The version number of the tutorial */
  version: _propTypes.default.number.isRequired,

  /** The environment of the tutorial api that needs talking to. One of: dev, test, preprod, prod */
  environment: _propTypes.default.string.isRequired,

  /** Indicates whether the steps within the tutorial should not be able to be skipped */
  notSkippable: _propTypes.default.bool
};
Tutorial.defaultProps = {
  notSkippable: false
};
var _default = Tutorial;
exports.default = _default;